<template>
  <div class="wrapper">
    <div class="main-top">
      <el-row type="flex" align="middle" justify="space-between">
        <div class="mtl-wrap">
          <div class="mtl">
            <router-link to="/">
              <div class="logo-icon">
                <img :src="$store.state.config.shop_logo" alt>
              </div>
              <div class="logo-text">{{$store.state.config.shop_name}}</div>
            </router-link>
          </div>
        </div>

        <el-row type="flex" align="middle" justify="space-between" class="mtr">
          <div class="nav">
            <div class="nav-item all" :class="{'active':this.$route.name!=='home'}" @mouseover="showAllNav=true" @mouseleave="showAllNav=false">
              <span>全部商品分类</span>
              <div class="nav-wrap" v-show="showAllNav">
                <all-classify></all-classify>
              </div>
            </div>
            <template v-if="shopMenu.menu">
              <div class="nav-item" v-for="(item,index) in shopMenu.menu.nav" :key="index" @mouseover="changeNav(item)" @mouseleave="showDraw=false">
                <template v-if="item.type==4">
                  <!--商品列表 -->
                  <a href="javascript:;" @click="searchItem(item)">
                    <span>{{item.name}}</span>
                  </a>
                </template>
                <template v-else-if="item.type==1">
                  <!--url -->
                  <a :href="item.data">
                    <span>{{item.name}}</span>
                  </a>
                </template>
                <template v-else-if="item.type==3">
                  <!--文章详情 -->
                  <span @click="toArticle(item)">{{item.name}}</span>
                </template>
                <template v-else-if="item.type==2">
                  <!--文章分类 -->
                  <router-link :to="{name:'help',query:{type:item.type,id:item.data}}">{{item.name}}</router-link>
                </template>
                <template v-else-if="item.type==5">
                  <!--商品详情 -->
                  <router-link :to="{name:'detail',params: {goodsId:item.goods_id}}">{{item.name}}</router-link>
                </template>
                <template v-if="item.type==6">
                  <!--二级菜单 -->
                  <a href="javascript:;">
                    <span>{{item.name}}</span>
                  </a>
                </template>
              </div>
            </template>
          </div>
          <div class="search" :class="inputFocus?'active':''">
            <input type="text" v-model="input" placeholder class="search-input" @focus="inputFocus=true" @blur="inputFocus=false" @keyup.enter="jumpToSearch">
            <div class="search-icon-wrap" :class="inputFocus?'active':''" @click="jumpToSearch">
              <div class="search-icon">
                <i class="el-icon-search"></i>
              </div>
            </div>
            <div class="tip-search" v-show="!inputFocus&&!input">
              <router-link :to="{name:'search', query: {key:item,name:item}}" v-for="(item,index) in keywords" :key="index">{{item}}</router-link>
            </div>
          </div>
        </el-row>
      </el-row>
    </div>
    <el-collapse-transition>
      <div class="tui-wrap" v-show="showDraw" @mouseover="showDraw=true" @mouseleave="showDraw=false">
        <div class="tui-main">
          <el-carousel indicator-position="outside" style="width:100%;height:100%;">
            <el-carousel-item v-for="(item,i) in resultList" :key="i" class="list">
              <div v-for="(shop,index) in item" :key="index" class="pro" style="float:left">
                 <a href="javascript:;" @click="lookDetail(shop.id)">
                  <div class="pro-img" v-show="shop.image_url">
                    <img v-lazy="shop.image_url" :alt="shop.name" :key="shop.image_url">
                  </div>
                  <div class="title">{{shop.name}}</div>
                  <div class="price">{{shop.price}}元</div>
               </a>
              </div>
            </el-carousel-item>
          </el-carousel>
          <!-- <div class="pro" v-for="(item,index) in proList" :key="index">
            <a href="javascript:;" @click="lookDetail(item.id)">
              <div class="pro-img">
                <img :src="item.image_url" alt>
              </div>
              <div class="title">{{item.name}}</div>
              <div class="price">{{item.price}}元</div>
            </a>
          </div> -->
        </div>
      </div>
    </el-collapse-transition>
  </div>
</template>
<script>
import AllClassify from '@/components/common/AllClassify.vue'
import { mapState } from 'vuex'
export default {
  name: 'MainTop',
  components: {
    AllClassify,
  },
  data() {
    return {
      keywords: null,
      showDraw: false,
      input: '',
      inputFocus: false,
      showAllNav: false,
      proList: [],
      menuTopList: [],
      resultList: [],
    }
  },
  computed: {
    ...mapState({
      shopMenu: state => state.shopMenu,
    }),
  },
  watch: {
    '$route.params'() {
      if (this.$route.params.key) {
        this.input = this.$route.params.key
      }
    },
  },
  mounted() {},
  created() {
    this.$api.getRecommendKeys().then(res => {
      if (res.status) {
        this.keywords = res.data
      }
    })
  },
  methods: {
    //查看文章
    toArticle(item) {
      this.$router.push({
        name: 'help',
        query: { article_id: item.article_id },
      })
      this.showDraw = false
    },
    searchItem(item) {
      console.log(item)
      this.$router.push({
        name: 'search',
        query: { id: item.id, name: item.name },
      })
      this.showDraw = false
    },
    changeNav(item) {
      if (
        item.data &&
        item.data.constructor &&
        item.data.constructor === Array &&
        item.data.length > 0
      ) {
        this.showDraw = true
        this.proList = item.data
        console.log(this.proList)
        var result = []
        for (var i = 0, len = this.proList.length; i < len; i += 6) {
          result.push(this.proList.slice(i, i + 6))
        }
        // console.log(result)
        this.resultList = result
      } else {
        this.showDraw = false
      }
    },
    lookDetail(id) {
      this.showDraw = false
      this.$router.push({ name: 'detail', params: { goodsId: id } })
    },
    jumpToSearch() {
      if (this.input) {
        this.$router.push({
          name: 'search',
          query: { key: this.input, name: this.input },
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/mixin.scss';
@import '@/assets/css/variable.scss';
.wrapper {
  width: 100%;
  background: #fff;
  position: relative;
  .main-top {
    width: 1226px;
    margin: 0 auto;
    height: 100px;
    padding: 0;
    .el-row {
      height: 100%;
      .mtl-wrap {
        width: 234px;
      }
      .mtl {
        a {
          display: inline-flex;
          align-items: center;
        }
        .logo-icon {
          width: 48px;
          height: 48px;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .logo-text {
          font-size: 15px;
          padding: 0 10px;
          @include line-height(24px);
          color: rgba(51, 51, 51, 1);
        }
      }
      .mtr {
        flex: 1;
        .nav {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          height: 100px;
          .nav-item {
            height: 100px;
            line-height: 100px;
            text-align: center;
            cursor: pointer;
            font-size: 16px;
            a {
              display: block;
            }
            &:first-of-type {
              span {
                padding-left: 0;
              }
            }
            span {
              display: block;
              padding: 0 18px;
              &:hover {
                color: $theme-color;
              }
            }
          }
        }
        .search {
          width: 295px;
          height: 50px;
          background: rgba(255, 255, 255, 1);
          border: 1px solid rgba(220, 220, 220, 1);
          padding: 10px 0 10px 10px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          align-items: center;
          transition: all 0.2s;
          position: relative;
          &.active {
            border: 1px solid $theme-color;
          }
          .search-input {
            display: block;
            flex: 1;
            height: 20px;
          }
          .search-icon-wrap {
            display: inline-block;
            width: 50px;
            height: 50px;
            position: relative;
            border-left: 1px solid rgba(220, 220, 220, 1);
            transition: all 0.2s;
            cursor: pointer;
            &:hover {
              color: #fff;
              background: $theme-color;
            }
            &.active {
              border-color: $theme-color;
            }
            .search-icon {
              position: absolute;
              width: 20px;
              height: 20px;
              top: 15px;
              left: 15px;
              .el-icon-search {
                font-size: 20px;
              }
            }
          }
          .tip-search {
            position: absolute;
            top: 15px;
            right: 60px;
            height: 16px;
            line-height: 16px;
            font-size: 10px;
            a {
              display: inline-block;
              padding: 0 6px;
              background: #eee;
              color: #757575;
              margin-left: 5px;
              transition: all 0.2s;
              &:hover {
                color: #fff;
                background: $theme-color;
              }
            }
          }
        }
      }
    }
  }
  .tui-wrap {
    position: absolute;
    top: 100px;
    left: 0;
    z-index: 999;
    width: 100%;
    border-top: 1px solid $bc-l;
    background: #fff;
    box-shadow: 0 3px 4px rgba(0, 0, 0, 0.18);
    box-sizing: border;
    .tui-main {
      width: 1226px;
      height: 100%;
      height: 250px;
      margin: 0 auto;
      display: flex;
      justify-content: flex-start;
      flex-flow: row wrap;
      overflow: hidden;
      box-sizing: border;
      .pro {
        width: 204px;
        position: relative;
        padding-top: 35px;
        box-sizing: border-box;
        text-align: center;
        &:not(:last-of-type):after {
          content: '';
          display: block;
          width: 1px;
          height: 100px;
          background: $bc-l;
          position: absolute;
          right: 0;
          top: 38px;
        }
        a {
          display: block;
          width: 100%;
          height: 100%;
          .pro-img {
            width: 110px;
            height: 110px;
            margin: 0 auto 20px;
            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
          .title {
            color: #333;
            font-size: 12px;
            line-height: 16px;
            width: 80%;
            color: #666;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-align: left;
            height: 32px;
            margin: 10px auto;
          }
          .price {
            color: $theme-color;
            font-size: 14px;
          }
          .tag {
            position: absolute;
            top: 0px;
            left: 50%;
            width: 66px;
            height: 22px;
            line-height: 22px;
            border: 1px solid $theme-color;
            color: $theme-color;
            font-size: 12px;
            margin-left: -33px;
          }
        }
      }
    }
  }
  .nav-item.all {
    position: relative;
    display: none;
    .nav-wrap {
      position: absolute;
      top: 100px;
      left: -70px;
      height: 440px;
    }
  }
  .nav-item.all.active {
    display: block;
  }
}
</style>


